const styles = (theme) => ({
  floatingBlue: {
    backgroundColor: theme.palette.primary.main,
    position: 'absolute',
    width: 30,
    height: 30,
  },
  floatingGray: {
    backgroundColor: theme.palette.background.default,
    width: 30,
    height: 30,
    borderRadius: '20px 0 0 0',
  },
  floatingWhite: {
    backgroundColor: theme.palette.white,
    width: 30,
    height: 30,
    borderRadius: '20px 0 0 0',
  },
  whiteLabel: {
    backgroundColor: theme.palette.layout.main,
  },
})

export default styles
